import React from 'react';
import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import SorteioScreen from '../../components/SorteioScreen';

const SorteioPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Navegar diretamente para o dashboard admin em vez de usar o histórico
    navigate('/admin');
  };

  return (
    <Box height="100vh" width="100%" bg="black">
      <SorteioScreen onBack={handleBack} />
    </Box>
  );
};

export default SorteioPage;
